import api from '../utils/api';

export const getStaffList = affiliateId =>
  api(`/gems/affiliates/${affiliateId}/staff_users`)
    .then(resp => resp.json())
    .then(({ data: staffList }) => staffList.filter(staff => staff && staff.username &&
      !staff.username.includes('@keypr.com') &&
      !staff.username.includes('@intelity.com') &&
      !staff.username.includes('@intelitycorp.com')));

export const getAffiliateLocations = affiliateId =>
  api(`/gems/affiliates/${affiliateId}/locations`)
    .then(resp => resp.json())
    .then(({ data: locations }) => locations);



// WEBPACK FOOTER //
// ./src/api/gems.js